module.exports = __webpack_public_path__ + "static/media/delhi.d460b508.svg";